import React from 'react';
import { Cpu, Brain, Sparkles } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const WizantixAI: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-background to-background/90 py-16 md:py-24">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary ring-1 ring-inset ring-primary/20 mb-6">
            <Brain size={16} className="mr-1" />
            <span>Powered by Advanced AI</span>
          </div>
          
          <h2 className="mb-6 text-3xl font-bold sm:text-4xl md:text-5xl">
            WIZANTIX-AI Gaming Platform
          </h2>
          
          <p className="mb-8 text-lg text-muted-foreground">
            Our games are powered by the cutting-edge WIZANTIX-AI platform, which combines advanced AI models, natural language processing, and game development expertise to transform your ideas into playable games.
          </p>
          
          <div className="grid gap-8 md:grid-cols-3">
            <div className="rounded-xl border border-border bg-card p-6">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Brain className="h-6 w-6" />
              </div>
              <h3 className="mb-2 text-lg font-semibold">Advanced AI Models</h3>
              <p className="text-sm text-muted-foreground">
                State-of-the-art language models and computer vision systems that understand your game concepts.
              </p>
            </div>
            
            <div className="rounded-xl border border-border bg-card p-6">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Cpu className="h-6 w-6" />
              </div>
              <h3 className="mb-2 text-lg font-semibold">Game Generation</h3>
              <p className="text-sm text-muted-foreground">
                Automated game logic creation, asset generation, and code synthesis for rapid development.
              </p>
            </div>
            
            <div className="rounded-xl border border-border bg-card p-6">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Sparkles className="h-6 w-6" />
              </div>
              <h3 className="mb-2 text-lg font-semibold">Smart Optimization</h3>
              <p className="text-sm text-muted-foreground">
                AI-driven performance optimization and gameplay balancing for the best player experience.
              </p>
            </div>
          </div>
          
          <div className="mt-12">
            <Button
              size="lg"
              as="a"
              href="https://wizantix.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More About WIZANTIX-AI
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default WizantixAI;